/**
 * This function takes a track title and splits it into two parts: the main title and any additional information in parentheses.
 * @param title The full title of the track.
 * @returns An array of two items containing the main title and the additional information in parentheses, if it exists, otherwise an empty string.
 */
export const getTrackTitleAsArray = (title: string) => {
  const titleMatch = title.match(/(.*?)(\s*\(.*\))?$/);

  return titleMatch ? [titleMatch[1], titleMatch[2] ?? ''] : [title, ''];
};
